import React from "react";
import {useParams, Link, useNavigate, useLocation} from "react-router-dom";
import { motion } from "framer-motion";
import styles from "./DanceStyleDetail.module.scss";
import vid from "../../videos/rumba.mp4";
import bachata from "../../videos/bachata3.mp4"
import drustveni from "../../videos/bachata3.mp4";
import tango from "../../videos/tango.mp4";
import moderan  from "../../videos/moderan.mov"

const danceDetails = {
  latino: {
    title: "Latino-američki plesovi",
    description: "Latino-američki plesovi su energični i strastveni. Obuhvataju sambu, ča-ča-ča, rumbu, paso doble i jive.",
    vid: `${vid}`
  },
  standard: {
    title: "Standardni plesovi",
    description: "Ovi plesovi su graciozni i formalni, uključuju valcer (engleski i bečki), tango, quickstep i slowfox.",
    vid: `${tango}`
  },
  caribbean: {
    title: "Karipski društveni plesovi",
    description: "Karakteriše ih senzualnost i ritam, a uključuju salsu, bachatu, merenge i kizombu.",
    vid: `${bachata}`
  },
  social: {
    title: "Društveni plesovi",
    description: "Društveni plesovi su zabavni i ležerni, uključuju swing, rock'n'roll, foxtrot i argentinski tango.",
    vid: `${drustveni}`
  }
};

const DanceStyleDetail = () => {
  const { styleId } = useParams();
  const dance = danceDetails[styleId];

  const navigate = useNavigate();
  const location = useLocation();

  const handleNavigation = (sectionId) => {
    if (location.pathname !== "/") {
      // Ako nisi na "/" -> idi na "/"
      navigate("/");

      // Sačekaj da se ruta promeni, pa onda skroluj
      setTimeout(() => {
        document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
      }, 100); // Blaga pauza da sačekamo učitavanje stranice
    } else {
      // Ako si već na "/" -> samo skroluj
      document.getElementById(sectionId)?.scrollIntoView({ behavior: "smooth" });
    }
  };

  if (!dance) return <p>Ne postoji tražena ponuda.</p>;

  return (
    <motion.section
      className={styles.danceDetail}
      initial={{ opacity: 0, x: -50 }}
      animate={{ opacity: 1, x: 0 }}
      exit={{ opacity: 0, x: 50 }}
      transition={{ duration: 0.5 }}
    >
      <video className={styles.video} src={dance.vid} autoPlay loop muted playsInline/>
      <div className={styles.content}>
        <h2>{dance.title}</h2>
        <p>{dance.description}</p>
        <Link onClick={handleNavigation("izbor")} className={styles.backButton}>Nazad</Link>
      </div>
    </motion.section>
  );
};

export default DanceStyleDetail;
